// extracted by mini-css-extract-plugin
export var active = "_h0-7";
export var blink = "_h0-8";
export var dropDownSelector = "_h0-4";
export var dropDownWrapper = "_h0-3";
export var fakeCursor = "_h0-6";
export var fontSizeButton = "_h0-9";
export var formQuillEditor = "_h0-0";
export var pressed = "_h0-a";
export var qlBlank = "_h0-1";
export var textFormattingToolbar = "_h0-2";
export var textToolbarOption = "_h0-5";